/* eslint-disable react/prop-types */
import React from 'react'
import Modal from 'react-modal'
import { useTranslation } from 'react-i18next'
import GoalForm from './GoalForm'

const GoalModal = ({ showModal, closeModal, fetchGoals }) => {
  const { t } = useTranslation()

  return (
    <Modal
      isOpen={showModal}
      onRequestClose={closeModal}
      contentLabel={t('curriculums.goalModal.contentLabel')}
    >
      <div className='modal-header row'>
        <div className='col-10'>
          <h5 className='modal-title display-4 uppercase detail-title'>
            {t('curriculums.common.addGoalTemplate')}
          </h5>
        </div>
        <div className='col-2'>
          <button
            type='button'
            className='close pull-right font-200 modal-close-btn'
            data-dismiss='modal'
            aria-label={t('common.close')}
            onClick={closeModal}
          >
            <span aria-hidden='true'>✕</span>
          </button>
        </div>
      </div>
      <GoalForm closeModal={closeModal} fetchGoals={fetchGoals} />
    </Modal>
  )
}

export default GoalModal
